const navToggleOpen = document.querySelector(".js-open-nav");
const navToggleClose = document.querySelector(".js-close-nav");
const siteNavigation = document.querySelector(".site-navigation");
const body = document.body;

function openNavigation() {
    siteNavigation.classList.add("is-active");
    body.classList.add("no-scroll");

    // Reveal nav items one by one
    const items = siteNavigation.querySelectorAll(".menu > ul > li");
    items.forEach((item, index) => {
        item.style.transitionDelay = `${index * 100}ms`;
        item.classList.add("is-visible");
    });
}

function closeNavigation() {
    siteNavigation.classList.remove("is-active");
    body.classList.remove("no-scroll");

    // Hide nav items
    const items = siteNavigation.querySelectorAll(".menu > ul > li");
    items.forEach((item) => {
        item.classList.remove("is-visible");
        item.style.transitionDelay = "";
    });
}

// Open button
navToggleOpen?.addEventListener("click", openNavigation);

// Close button
navToggleClose?.addEventListener("click", closeNavigation);

// Add ESC key functionality to close the navigation
document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
        closeNavigation(); // Close navigation when ESC is pressed
    }
});